export function stripScripts(html: string): string {
  return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
}

export function containsJavaScript(html: string): boolean {
  if (/<script[\s>]/i.test(html)) return true;
  if (/\bon\w+\s*=/i.test(html)) return true;
  if (/javascript\s*:/i.test(html)) return true;
  return false;
}

export enum IFrameServiceType {
  GOOGLE_MAP = 'googleMap',
  YOUTUBE = 'youtube',
  INSTAGRAM = 'instagram',
}

export function validateIframeSrc(html: string, serviceType: IFrameServiceType): string | null {
  if (containsJavaScript(html)) {
    return 'JavaScript is not allowed. Script tags, event attributes (e.g. onclick), and javascript: cannot be used.';
  }

  // Use DOMParser for robust iframe detection
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const iframes = doc.getElementsByTagName('iframe');

  if (iframes.length === 0) {
    return 'iframe tag not found.';
  }
  if (iframes.length > 1) {
    return 'Please enter only one iframe tag.';
  }

  const srcAttr = iframes[0].getAttribute('src');
  if (!srcAttr) {
    return 'src attribute not found in the iframe tag.';
  }
  const src = srcAttr.trim();

  // Use URL parser for secure domain validation
  let url: URL;
  try {
    url = new URL(src);
  } catch {
    return 'Invalid URL.';
  }

  if (url.protocol !== 'https:') {
    return 'Only https URLs are allowed.';
  }

  const hostname = url.hostname.toLowerCase();
  const { pathname } = url;

  switch (serviceType) {
    case IFrameServiceType.GOOGLE_MAP: {
      const isGoogleMapsDomain = (hostname.endsWith('google.com') && pathname.includes('/maps'))
        || hostname.startsWith('maps.google.');
      if (!isGoogleMapsDomain) {
        return 'Please enter a Google Maps iFrame.';
      }
      break;
    }
    case IFrameServiceType.YOUTUBE: {
      const isYouTubeDomain = hostname === 'youtu.be'
        || hostname === 'youtube.com'
        || hostname.endsWith('.youtube.com');
      if (!isYouTubeDomain) {
        return 'Please enter a YouTube iFrame.';
      }
      break;
    }
    case IFrameServiceType.INSTAGRAM: {
      const isInstagramDomain = hostname === 'instagram.com'
        || hostname.endsWith('.instagram.com');
      if (!isInstagramDomain) {
        return 'Please enter an Instagram iFrame.';
      }
      break;
    }
    default:
      break;
  }
  return null;
}
